import {Select} from "antd";
import React, {useEffect, useState} from "react";
import {getAllTenHang} from "../../../../api/weightSlip";
import {vnNormalize} from "../common/vnNormalize";

const SelectContentTenHangMobile = ({code, visible, defaultValueTh, setDefaultValue}) => {

    const Option = Select
    const [options, setOptions] = useState([])

    useEffect(() => {
        getAllTenHang(code, null).then(r => {
            setOptions(r)
        })
            .catch(() => {
            })
    }, [code])

    return (
        <div className={"pt-6 customer_select_mobile"}>
            <Select
                mode={"multiple"}
                maxTagCount={'responsive'}
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    vnNormalize(option.props.value.toLowerCase()).indexOf(input.toLowerCase()) >= 0
                    || option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                style={{width: "100%"}}
                value={defaultValueTh}
                onChange={(val)=>setDefaultValue(val)}
                placeholder={"Tên hàng"}
            >
                {options.map(p => <Option value={p}>{p}</Option>)}
            </Select>
        </div>
    )
}
export default SelectContentTenHangMobile
